import AISessionGenerator from '@/components/AIGeneration/AISessionGenerator';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/ai')({
  component: AIBuilder,
});

function AIBuilder() {
  return (
    <div className="max-w-2xl mx-auto py-5">
      <AISessionGenerator />
    </div>
  );
}
